<div class="form-step-fields" [formGroup]="form">
	@if (!hidesFieldTitleConfig && primaryField) {
		<div class="item-group">
			<span class="form-step-section-header">{{
				'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELDS_SECTION_HEADER' | translate
			}}</span>
		</div>

		<app-form-step-field-title-config
			[fieldGroup]="primaryField"
			[selectedLocaleId]="selectedLocaleId"
			[titleRequired]="fieldTitleRequired"
		/>
	}

	@if (usesLegalFieldsConfig && primaryField) {
		<tec-form-group
			[label]="('WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELDS_TITLE' | translate) + '*'"
			[description]="fieldsDescriptionKey | translate"
		>
			<div formArrayName="fields">
				<app-form-step-yes-no-preview />
				<app-form-step-rich-text-options-editor [fieldGroup]="primaryField" [selectedLocaleId]="selectedLocaleId" />
			</div>
		</tec-form-group>
	} @else if (usesYesNoPreview) {
		<tec-form-group
			[label]="('WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELDS_TITLE' | translate) + '*'"
			[description]="fieldsDescriptionKey | translate"
		>
			<div formArrayName="fields">
				<app-form-step-yes-no-preview />
			</div>
		</tec-form-group>
	} @else if (wrapFieldsInFormGroup && primaryField) {
		<tec-form-group
			[label]="('WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELDS_TITLE' | translate) + '*'"
			[description]="fieldsDescriptionKey | translate"
		>
			<div formArrayName="fields">
				@if (usesRichTextOptionsEditor) {
					<app-form-step-rich-text-options-editor
						[fieldGroup]="primaryField"
						[selectedLocaleId]="selectedLocaleId"
					/>
				} @else {
					<app-form-step-options-editor [fieldGroup]="primaryField" [selectedLocaleId]="selectedLocaleId" />
				}
			</div>
		</tec-form-group>
	} @else {
		<tec-form-group
			[label]="('WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELDS_TITLE' | translate) + '*'"
			[description]="fieldsDescriptionKey | translate"
		>
			<div formArrayName="fields">
				<app-form-step-field-preview-list [fieldsArray]="fieldsArray" [preset]="preset" />
			</div>
		</tec-form-group>
	}
</div>
